var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "27px",
    viewBox: "0 0 27 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "The-card",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "The-Card---Desktop",
    transform: "translate(-1207.000000, -1385.000000)",
    fill: "#E5E1EB",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(119.000000, 860.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1114.02613,525.90621 C1112.86682,524.747504 1110.98757,524.747504 1109.82826,525.90621 L1101.43253,534.303059 L1093.03681,525.90621 C1092.29142,525.134624 1091.18762,524.825178 1090.14964,525.096808 C1089.11167,525.368438 1088.30105,526.178872 1088.02936,527.216619 C1087.75767,528.254366 1088.06719,529.357928 1088.83894,530.10315 L1097.23467,538.5 L1088.83894,546.89685 C1088.06719,547.642072 1087.75767,548.745634 1088.02936,549.783381 C1088.30105,550.821128 1089.11167,551.631562 1090.14964,551.903192 C1091.18762,552.174822 1092.29142,551.865376 1093.03681,551.09379 L1101.43253,542.696941 L1109.82826,551.09379 C1110.57365,551.865376 1111.67745,552.174822 1112.71543,551.903192 C1113.7534,551.631562 1114.56402,550.821128 1114.83571,549.783381 C1115.1074,548.745634 1114.79788,547.642072 1114.02613,546.89685 L1105.6304,538.5 L1114.02613,530.10315 C1115.18509,528.944095 1115.18509,527.065265 1114.02613,525.90621 L1114.02613,525.90621 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayXIcon);
export default __webpack_public_path__ + "static/media/gray_x_icon.73ddb1b4fc0ba2c7ff53f679bff680b6.svg";
export { ForwardRef as ReactComponent };